import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useSortable } from '@dnd-kit/sortable';
import { Box, Typography, IconButton, Stack } from '@mui/material';
import React, { useState, useEffect } from 'react';
import defaultAlbumThumbnail from '../../assets/default_album_thumbnail.svg';
import theme from '../../theme';
import CloseIcon from '@mui/icons-material/Close';
import AlbumTitleLink from '../../components/common/AlbumTitleLink';

const SortableItemMO = ({ item, index, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: item.sourceId,
  });

  const [imageSrc, setImageSrc] = useState(item.albumImageUrl || defaultAlbumThumbnail);

  useEffect(() => {
    setImageSrc(item.albumImageUrl || defaultAlbumThumbnail);
  }, [item.albumImageUrl]);

  const handleError = () => {
    setImageSrc(defaultAlbumThumbnail);
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    alignItems: 'flex-start',
    borderRadius: '4px',
    padding: '16px',
    userSelect: 'none',
    minHeight: '89px',
    minWidth: '320px',
    backgroundColor: theme.palette.grey.bg,
  };

  return (
    <Box ref={setNodeRef} style={style}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1 }}>
        <Box
          {...attributes}
          {...listeners}
          sx={{
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
            touchAction: 'none',
            alignSelf: 'center',
          }}
        >
          <DragIndicatorIcon
            sx={{ width: '24px', height: '24px', color: theme.palette.black[3] }}
          />
        </Box>
        <Stack spacing={1} flex={1} direction="row" alignItems="flex-start">
          <Typography
            variant="body5"
            sx={{ fontWeight: 'bold', fontColor: theme.palette.black[9], alignSelf: 'center' }}
          >
            {index + 1}
          </Typography>
          <Box sx={{ width: 32, height: 32, flexShrink: 0, alignSelf: 'center' }}>
            <img
              src={imageSrc}
              alt={item.title}
              onError={handleError}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
          <Stack spacing={1} sx={{ alignSelf: 'center' }}>
            <AlbumTitleLink
              title={item.title}
              contentRating={item.contentRating}
              lineClamp={3}
              sx={{
                fontSize: '13px',
              }}
              iconSx={{
                width: '12px',
                height: '12px',
                marginLeft: 0.5,
              }}
            />
            <Typography variant="body5" color={theme.palette.black[4]}>
              {item.artist?.name || item.artistName}
            </Typography>
            <Typography variant="body5" color={theme.palette.black[4]}>
              {item.releaseDate}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      {/* 삭제 버튼 */}
      <IconButton
        onClick={() => onRemove(item)}
        sx={{ width: '16px', height: '16px', alignSelf: 'flex-start' }}
      >
        <CloseIcon sx={{ width: '16px', height: '16px', color: theme.palette.black[3] }} />
      </IconButton>
    </Box>
  );
};

export default SortableItemMO;
